<template>
  <section>
    <workout-listing />
  </section>
</template>
<script>
import WorkoutListing from '@/Components/Workouts/workouts-listing'
export default {
  name: 'workouts',
  components: {
    WorkoutListing,
  },
}
</script>
<style lang="scss" scoped>
</style>
